import React from "react";
import { useTranslation } from "react-i18next";
import Button from "./Button";
import Input from "./Input";
import Modal from "./Modal";

const EditNameModal = ({
  title,
  label,
  value,
  saveText,
  loading = false,
  onChange,
  onSave,
  onCancel,
}) => {
  const { t } = useTranslation("common");
  const resolvedSaveText = saveText ?? t("actions.save");

  const onSubmit = (e) => {
    e.preventDefault();
    onSave();
  };

  return (
    <Modal
      title={title}
      onClose={onCancel}
      busy={loading}
      maxWidth={420}
      footer={
        <>
          <Button variant="secondary" onClick={onCancel} disabled={loading} type="button">{t("actions.cancel")}</Button>
          <Button onClick={onSubmit} disabled={loading}>{loading ? t("editNameModal.saving") : resolvedSaveText}</Button>
        </>
      }
    >
      <form onSubmit={onSubmit}>
        <Input label={label} value={value} onChange={(e) => onChange(e.target.value)} placeholder={t("editNameModal.placeholder")} required autoFocus style={{ marginBottom: 0 }} />
      </form>
    </Modal>
  );
};

export default EditNameModal;
